var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project__edit__wrapper", attrs: { id: "project" } },
    [
      _c("HeaderControlsProject", {
        attrs: { myWeek: false },
        on: { filterUpdated: false, collapseToggleUpdated: false }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid project--details" },
        [_c("ProjectDeliverableList")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }